import { render, staticRenderFns } from "./AuthLogout.vue?vue&type=template&id=0493a9de"
import script from "./AuthLogout.vue?vue&type=script&lang=js"
export * from "./AuthLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports